async function fetchCrossSell() {
  const response = await fetch(
    "https://backend.heliumbuilder.com" + "/cross-sell/cc",
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const data = await response.json();

  window.heliumCrossSellProducts = data;

  return transformProducts(data ?? []);
}

async function fetchPaginatedListingIds(
  handles: string[],
  refreshProductInfo = false,
) {
  const breakpoint = 100;

  const firstHalf = handles.slice(0, breakpoint);
  const secondHalf = handles.slice(breakpoint);

  const [firstHalfListings, secondHalfListings] = await Promise.all([
    fetchListingId(firstHalf, refreshProductInfo),
    fetchListingId(secondHalf, refreshProductInfo),
  ]);

  return {
    ...firstHalfListings,
    ...secondHalfListings,
  };
}

async function fetchListingId(handles: string[], refreshProductInfo = false) {
  const response = await fetch(
    "https://culture-circle.azurewebsites.net/graphql",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        variables: {
          slug: handles,
        },
        query: `query GetProductDetailsWithRelatedAndTrending($slug: [String!]!) {
  productDetail: allProducts(
    filters: {slug: {inList: $slug}}
    first: ${handles.length}
  ) {
    edges {
      node {
      skuId
      title
      slug
      images {
        edges {
          node {
            image
          }
        }
      }
      brandName
        variants {
          edges {
            node {
                id
                title
              listings(first: 100, filters: {isOnline: {exact: true}}) {
                edges {
                  node {
                    id
                    price
                    seller
                    shippingTime
                    shippingCost
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}`,
      }),
    },
  );

  const res = await response.json();

  const productDetails = res.data.productDetail.edges.map((e) => e.node);

  const listings: {
    [key: string]: {
      variantId: string;
      variantTitle: string;
      listing: {
        id: string;
      };
    }[];
  } = {};

  for (const product of productDetails) {
    if (refreshProductInfo) {
      window.heliumCrossSellProducts.push({
        ...product,
        handle: product.slug,
        slug: product.slug,
        imageUrl: product.images.edges[0].node.image,
      });
    }

    const listingIds = product.variants.edges.map((e) => {
      const chosenListing = e.node.listings.edges.sort((a, b) => {
        b.node.price - a.node.price;
      })?.[0]?.node;

      return {
        variantId: e.node.id,
        variantTitle: e.node.title,
        listing: chosenListing,
      };
    });

    if (listings[product.slug]) {
      listings[product.slug].push(...listingIds);
    } else {
      listings[product.slug] = listingIds;
    }
  }

  return listings;
}

function transformProducts(products: any) {
  const response = products
    .filter((e) => e?.isActive)
    .map((e) => ({
      title: e?.title,
      handle: e?.slug,
      price: e?.price?.toLocaleString(),
      image:
        e?.imageUrl ??
        e?.images?.find?.((e) => e?.image)?.image ??
        e?.images?.find?.((e) => e?.thumbnail)?.thumbnail ??
        "",
    }));

  return response;
}

function addCrossSellToCheckout(products: any) {
  if (
    !window.location.pathname.includes("/checkout") ||
    document.querySelector("[data-helium-pair-it-with='true']")
  ) {
    return;
  }

  const insertBeforeElement = document.querySelector(
    "body > div.max-w-xl.mx-auto.p-4.bg-gray-100.min-h-screen > div > div.space-y-3",
  );

  if (!insertBeforeElement) return;

  const productListItems = productList(
    products.map((e) => product(e.title, e.handle, e.price, e.image)),
  );
  const newDiv = document.createElement("div");
  newDiv.setAttribute("data-helium-pair-it-with", "true");
  newDiv.innerHTML = productListItems;

  insertBeforeElement.before(newDiv);
}

const productList = (products) =>
  `<div class="space-y-3"><h3 class="text-sm font-medium flex gap-1 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-grid2x2-plus h-4 w-4"><path d="M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3"></path><path d="M16 19h6"></path><path d="M19 22v-6"></path></svg>Pair it with</h3><div dir="ltr" class="relative overflow-hidden w-full whitespace-nowrap rounded-lg shadow-sm bg-white px-0" style="position: relative; --radix-scroll-area-corner-width: 0px; --radix-scroll-area-corner-height: 0px;"><style>[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}</style><div data-radix-scroll-area-viewport="" class="h-full w-full rounded-[inherit]" style="overflow: scroll;"><div style="min-width: 100%; display: table;"><div class="flex gap-4 px-1 py-4">${products.join(" ")}</div></div></div></div></div>`;
const product = (title, handle, price, image) =>
  `<div class="w-[100px]"><div class="relative shrink-0 border rounded-lg"><button onclick="window.heliumATC('${handle}')" class="absolute -right-2 -top-2 w-5 h-5 rounded-md bg-white border flex items-center justify-center" aria-label="Add Yeezy Boost 350 V2 Bone to cart"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus h-3 w-3"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg></button><img alt="${title}" loading="lazy" width="120" height="120" decoding="async" data-nimg="1" class="rounded-lg object-cover" srcset="${image} 1x, ${image} 2x" src="${image}" style="color: transparent;height:80px;"></div><h4 class="text-xs mt-2 truncate">${title}</h4><p class="text-xs text-gray-500">₹${price}</p></div>`;
const bottomSheet = (open, items, title, img) =>
  `<div role="dialog" id="radix-:r3:" aria-describedby="radix-:r5:" style="height:80vh" aria-labelledby="radix-:r4:" data-state="${open ? "open" : "closed"}" class="fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom rounded-t-3xl" tabindex="-1" style="pointer-events: auto;"><button onclick="window.heliumClose()" type="button" class="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"><path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg><span class="sr-only">Close</span></button><div class="flex flex-col space-y-2 text-center sm:text-left"><h2 id="radix-:r4:" class="text-lg font-semibold text-foreground">${title}</h2></div><div dir="ltr" class="relative overflow-hidden h-full mt-4" style="position: relative; --radix-scroll-area-corner-width: 0px; --radix-scroll-area-corner-height: 0px;"><style>[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}</style><div data-radix-scroll-area-viewport="" class="h-full w-full rounded-[inherit]" style="overflow: hidden scroll;"><img src="${img}" alt="Product image" height="auto" width="100%" style="margin:auto;max-height:400px;object-fit:cover;object-position:center;max-width:500px" /><div style="min-width: 100%; display: table;"><div class="space-y-1">${items}</div></div></div></div></div>`;
const overlay = (open) =>
  `<div onclick="window.heliumClose()" data-state="${open ? "open" : "closed"}" class="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" style="pointer-events: auto;" data-aria-hidden="true" aria-hidden="true">

</div>`;
const variantButton = (title, id, price, handle) =>
  `<button onclick="window.selectVariant('${handle}', '${id}')" class="w-full p-3 text-left hover:bg-gray-100 rounded-lg transition-colors"><div class="flex justify-between items-center"><div><p class="font-medium">${title}</p><p class="text-sm text-gray-500">₹${price.toLocaleString()}</p></div></div></button>`;

window.heliumATC = function (handle) {
  const listing = window.heliumListings[handle];
  const productInfo = window.heliumCrossSellProducts.find(
    (e) => e.slug === handle,
  );
  const variants = listing
    .filter((e) => !!e.listing && !!e.listing.price)
    .map((e) =>
      variantButton(e.variantTitle, e.variantId, e.listing.price, handle),
    )
    .join("");

  const html =
    overlay(true) +
    bottomSheet(true, variants, productInfo.title, productInfo.imageUrl);

  const div = document.createElement("div");
  div.setAttribute("data-helium-overlay", "helium");
  div.innerHTML = html;

  document.body.appendChild(div);
};

window.selectVariant = function (handle, variantId) {
  const listing = window.heliumListings[handle];
  const productInfo = window.heliumCrossSellProducts.find(
    (e) => e.slug === handle,
  );
  const variantInfo = listing.find((e) => e.variantId === variantId);

  const item = {
    id: variantInfo.listing.id,
    name: productInfo.title,
    price: variantInfo.listing.price,
    skuId: productInfo.skuId,
    quantity: 1,
    image: productInfo.imageUrl,
    variant: variantInfo.variantTitle,
    brandName: productInfo.brandName,
    seller: variantInfo.listing.seller,
    variant_id: variantInfo.listing.id,
    product_id: productInfo.skuId,
  };

  const currentCart = JSON.parse(localStorage.getItem("cart") ?? "[]");

  localStorage.setItem("cart", JSON.stringify([...currentCart, item]));

  window.location.reload();
};

window.heliumClose = function () {
  document
    .querySelectorAll("[data-helium-overlay='helium']")
    .forEach((e) => e.remove());
};

async function fetchAllListings(products: any, refreshProductInfo = false) {
  const handles = products.map((e) => e.handle);

  const listings = await fetchPaginatedListingIds(handles, refreshProductInfo);

  window.heliumListings = {
    ...(window.heliumListings ?? {}),
    ...listings,
  };

  return listings;
}

async function fetchAllListingsWithPagination(
  products: any,
  refreshProductInfo = false,
) {
  const breakpoint = 100;

  const firstHalf = products.slice(0, breakpoint);
  const secondHalf = products.slice(breakpoint, 200);

  const [firstHalfListings, secondHalfListings] = await Promise.all([
    fetchAllListings(firstHalf, refreshProductInfo),
    fetchAllListings(secondHalf, refreshProductInfo),
  ]);

  return {
    ...firstHalfListings,
    ...secondHalfListings,
  };
}

window.fetchAndEmbedListings = fetchAllListingsWithPagination;

export async function setupCrossSell() {
  fetchCrossSell().then((e) => {
    addCrossSellToCheckout(e);
    fetchAllListings(e);
  });
}

export const crossSellVariable = "123";
